/**
 * ChapterEyebrow.jsx
 * Tiny sub-eyebrow that sits at the top of each major homepage section,
 * so the reader always knows which chapter they're in while scrolling.
 *
 * <ChapterEyebrow number="01" title="CSR / Impact" />
 */
import React from 'react';
import { motion } from 'framer-motion';

export default function ChapterEyebrow({ number, title, accent = 'var(--rebel-red, #CD2200)' }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: -4 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-40px' }}
      transition={{ duration: 0.5, ease: [0.2, 0.8, 0.2, 1] }}
      className="max-w-[1200px] mx-auto px-6 lg:px-8 pt-12 sm:pt-16"
      data-testid={`chapter-eyebrow-${number}`}
    >
      <div
        className="inline-flex items-center gap-2.5 text-[10px] sm:text-[11px] font-mono uppercase tracking-[0.22em]"
        style={{ color: 'var(--shell-text-muted)' }}
      >
        <span
          className="inline-flex items-center justify-center min-w-[28px] h-5 px-1.5 rounded-sm font-bold"
          style={{
            background: `${accent}10`,
            border: `1px solid ${accent}45`,
            color: accent,
            letterSpacing: '0.14em',
          }}
        >
          {number}
        </span>
        <span
          className="inline-block h-px"
          style={{ width: 22, background: 'var(--shell-border)' }}
          aria-hidden
        />
        <span style={{ color: 'var(--shell-text)', fontWeight: 600 }}>{title}</span>
      </div>
    </motion.div>
  );
}
